interface IconNurseFilledProps {
  size?: number | string;
  color?: string;
  className?: string;
}
/**
 *
 * IconNurseFilled
 */
const IconNurseFilled = ({ size = 48, color = '#33B2B9', className }: IconNurseFilledProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_516_33609)">
      <path
        d="M24.504 8.00003C30.236 8.00003 37.904 10.73 43.568 14.31C43.905 14.5229 44.1707 14.8315 44.3311 15.1964C44.4915 15.5613 44.5391 15.9658 44.468 16.358L40.468 38.358C40.3841 38.8189 40.1412 39.2356 39.7816 39.5357C39.4219 39.8358 38.9684 40.0001 38.5 40H10.5C10.0316 40.0001 9.57805 39.8358 9.2184 39.5357C8.85875 39.2356 8.61583 38.8189 8.53199 38.358L4.53199 16.358C4.46085 15.9658 4.50852 15.5613 4.66888 15.1964C4.82924 14.8315 5.09498 14.5229 5.43199 14.31C11.1 10.726 18.88 7.99003 24.504 8.00003ZM24.5 18C23.9696 18 23.4609 18.2107 23.0858 18.5858C22.7107 18.9609 22.5 19.4696 22.5 20V22H20.5C20.0101 22.0001 19.5373 22.1799 19.1712 22.5055C18.8052 22.831 18.5713 23.2795 18.514 23.766L18.5 24C18.5 24.5305 18.7107 25.0392 19.0858 25.4142C19.4609 25.7893 19.9696 26 20.5 26H22.5V28C22.5001 28.4899 22.6799 28.9627 23.0054 29.3288C23.3309 29.6948 23.7795 29.9287 24.266 29.986L24.5 30C25.0304 30 25.5391 29.7893 25.9142 29.4142C26.2893 29.0392 26.5 28.5305 26.5 28V26H28.5C28.9899 26 29.4627 25.8201 29.8287 25.4946C30.1948 25.1691 30.4287 24.7205 30.486 24.234L30.5 24C30.5 23.4696 30.2893 22.9609 29.9142 22.5858C29.5391 22.2107 29.0304 22 28.5 22H26.5V20C26.4999 19.5102 26.3201 19.0374 25.9946 18.6713C25.669 18.3052 25.2205 18.0713 24.734 18.014L24.5 18Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_516_33609">
        <rect width="48" height="48" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default IconNurseFilled;
